<template>
    <div class="home">
        <v-alert outlined text dense color="purple"> この画面は作成中です。</v-alert>

      <h2 class="mb-3">最近の更新１０社です</h2>

        <v-card class="my-3" max-width="1000" v-for="sup in latestSuppliers" :key="sup.id"><!-- class="mx-auto" -->
          <v-card-title>
                <router-link :to="{ name: 'supplier', params: { sup_cd: sup.id }}"> {{ sup.name }} <!--{{ sup.id }}-->
                </router-link>
              
               <v-chip v-if="sup.isNew"
                class=""
                color="red"
                text-color="white"
                small>
                NEW
              </v-chip>
          </v-card-title>
          <v-card-text>
              <v-container>
            
                <v-row>
                  <v-col cols="12" sm="12" md="3">
                  更新日：{{ formatDateToDisplay(sup.updateAt) }}
                  
                  </v-col> 
                  <v-col cols="12" sm="12" md="3">
                  更新者：{{ sup.updateUserName }}
                  </v-col> 
                  <v-col cols="12" sm="12" md="6">
                    {{ sup.address1 }}
                  </v-col>
                </v-row>  
                <v-row>
                  <v-col cols="12" sm="12" md="4">
                  <image-view v-if="sup.mainPhotoId" :height="200" :width="200"
                                        :image-id="sup.mainPhotoId"></image-view>
                  </v-col>
                  <v-col cols="4" class="py-0">
                    <table>
                      <tr v-for="mp in sup.evaluateScores" :key="mp.evaluateItemCd">
                        <td>{{ getEvaluateItemName(mp.evaluateItemCd)  }}</td> <!-- getEvaluateItemName -->
                        <td>
                          <v-rating
                              v-model="mp.score"
                              background-color="grey lighten-1"
                              color="yellow accent-4"
                              dense
                              small
                              half-increments
                              readonly
                          ></v-rating>
                        </td>
                      </tr>
                    </table>

                  </v-col>      
                </v-row>          
                    
              </v-container>
          </v-card-text>
              
        </v-card>

      <v-container>
        
        

        <v-row>
          <v-col>

            <h2 class="mb-3">最近の投稿ですYoYo</h2>

            <v-card class="mb-3" max-width="600" v-for="(row,idx) in reviews" :key="row.vendor_name"><!-- class="mx-auto" -->
              <v-container>
                <v-row>
                  <v-col cols="3">
                    <span>{{row.dt}} </span>
                    <br>
                    <router-link :to="{ name: 'supplier', params: { sup_cd: 1132 }}"> {{row.vendor_name}} </router-link>
                    <br>
                    <span>{{row.staff_name}}</span>
                  </v-col>
                  <v-col>
                    {{row.content}}
                  </v-col>
                </v-row>
              </v-container>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon v-on:click="onGoodClick"><v-icon>mdi-thumb-up-outline</v-icon></v-btn>

              </v-card-actions>
            </v-card>
          </v-col>


          <v-col class="ml-3">

            <h2>ポイントランキング</h2>
            <div class="mb-5">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th class="text-left">順位</th>
                    <th class="text-left">名前</th>
                    <th class="text-left">ポイント</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(row,idx) in ranking" :key="row.staff_name">
                    <td>{{"" + (idx+1) + "位"}}</td>
                    <td>{{ row.staff_name }}</td>
                    <td>{{ row.point }}p</td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>

              <router-link :to="{ name: 'user_ranking'}"> もっと見る </router-link>

            </div>
          </v-col>
        </v-row>
      </v-container>


    </div>

</template>
<script>
import ObjectParamSupport from "../components/ObjectParamSupport";
import BaseView from "../components/BaseView";
import ToppageAPI from "@/apis/ToppageAPI";

export default {
    mixins:[BaseView,ObjectParamSupport],
    components: {
    },
    props: [],
    data: () => ({
        isInitialized:false,
        isFetched:false,
        isLoading:false,
        isDownloading:false,

        condition:{},

        latestSuppliers:[
          {
            "id": 1300,
            "name": "タケウチゴーセイ(株)",
            "sname": "タケウチゴーセイ",
            "kana": "タケウチゴーセイ",
            "postalCd": "939-0351",
            "address1": "富山県射水市戸破針原8-15",
            "address2": "",
            "address3": "",
            "areaCd": "",
            "areaName": "",
            "tel": "0766-56-3131",
            "fax": "0766-56-0850",
            "president": "竹内　裕子",
            "url": "",
            "mainPhotoId": null,
            "totalSales": null,
            "mySales": null,
            "salesShare": null,
            "capital": null,
            "employeeNum": null,
            "systemCd": "001207",
            "priority": "",
            "remark": "",
            "createAt": "2021-03-25T00:00:00",
            "updateAt": "2021-06-24T08:47:37.469566",
            "deleteAt": null,
            "updateUserId":"",
            "updateUserName": "",
            "applications": [],
            "clients": [],
            "contractors": [],
            "equipments": [],
            "representatives": [],
            "images": [],
            "subSuppliers": [],
            "itemGroups": [],
            "isPs": false,
            "processGroups": [],
            isNew:false,
            isUpdated:false
          },
          {
            "id": 1299,
            "name": "扶桑鋼管(株)",
            "sname": "扶桑鋼管",
            "kana": "フソウコウカン",
            "postalCd": "923-0342",
            "address1": "石川県小松市矢田野町西32-15",
            "address2": "",
            "address3": "",
            "areaCd": "",
            "areaName": "",
            "tel": "0761-43-1122",
            "fax": "0761-43-1189",
            "president": "江村　伸一",
            "url": "",
            "mainPhotoId": null,
            "totalSales": null,
            "mySales": null,
            "salesShare": null,
            "capital": null,
            "employeeNum": null,
            "systemCd": "001208",
            "priority": "",
            "remark": "本社：千葉県浦安市美浜1-9-2",
            "createAt": "2021-04-05T00:00:00",
            "updateAt": "2021-06-24T08:47:37.037105",
            "deleteAt": null,
            "applications": [],
            "clients": [],
            "contractors": [],
            "equipments": [],
            "representatives": [],
            "images": [],
            "subSuppliers": [],
            "itemGroups": [],
            "isPs": false,
            "processGroups": []
          },   
        ],

        reviews:[
            {
                dt:"2020/07/25",
                vendor_name:"大野製作所",
                staff_name:"霜上 かよ",
                content:"通常納期6日のブロックを特急依頼で3時間で対応してもらいました。口の悪い社長ですので評価が低くなっていましたが、実は理解のある協力的な方なのだと感じました。",
            },
            {
                dt:"2020/07/23",
                vendor_name:"津幡メッキ工業",
                staff_name:"木野しょうこ",
                content:"粟津工場向けのブラケットでメッキ剥がれ確認。再メッキ依頼を行なったが、「材料が悪い」と逆にクレームを受けました。",
            },
            {
              dt:"2020/07/22",
              vendor_name:"栃木ドリル",
              staff_name:"墨谷 慎吾",
              content:"栃木ドリルさんに定期訪問。社長が真っ黒に日焼けしてました。",
            },
        ],

        ranking:[
            {
                staff_name:"沖野 つかさ",
                point:1100,
            },
            {
              staff_name:"霜上 かよ",
              point:980,
            },
            {
              staff_name:"前出 千尋",
              point:420,
            },
            {
              staff_name:"南口 宗太",
              point:210,
            },
            {
              staff_name:"墨谷 慎吾",
              point:200,
            }
        ],

        pager:{},
        errors:{},
    }),
    computed: {

    },
    mounted:function() {
        this.setupConditions();

          //ToppageAPI.listLatest10().then(response => {
          //    console.log("listLatest10",response);
          //});

    },
    created:function() {
      
    },
    watch: {
        '$route':function (to, from) {
            this.setupConditions();
        },
    },
    methods: {

 
        setupConditions(){
            let p = this.getObjectParam();
            if (p){
                // パラメータの転写
                
            }

            this.fetchData(true)

        },

        fetchData(needDataFetch){
            let self = this;
            if (!this.isInitialized){
                this.fetchBasicData(function () {
                    self.fetchData(needDataFetch)
                });
                return;
            }
            if (needDataFetch){
                this.isLoading = true;
                Promise.resolve()
                    .then(a => ToppageAPI.listLatest10())
                    .then(data => {
                  
                        this.makeDisplayData(data);
                    })
                    .catch(function(err) {
                        console.log(err);
                        self.showErrorToast("データの取得に失敗しました。");
                    });
            }
        },

        fetchBasicData(finishProc){
            this.isInitialized = true;
            if (finishProc){
                finishProc();
            }
        },

        onGoodClick(){
            this.showMessageToast("いいねしました。")
        },

      makeDisplayData(data) {

        this.logger.log("makeDisplayData", data)

        this.latestSuppliers.splice(0) // もともと入ってた値をクリアする
      
        data.forEach(rec => { // dataをグルグル回す
          
          //let supplier = rec; // 変数に保存
          rec.isNew = true;
          this.latestSuppliers.push(rec) // 表示用の配列に追加

        });

      
      }



    },

}
</script>